import { render, staticRenderFns } from "./faguiinfo.vue?vue&type=template&id=70288c02&scoped=true"
import script from "./faguiinfo.vue?vue&type=script&lang=js"
export * from "./faguiinfo.vue?vue&type=script&lang=js"
import style0 from "./faguiinfo.vue?vue&type=style&index=0&id=70288c02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70288c02",
  null
  
)

export default component.exports